




































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AppConsts from '@/lib/appconst';
import AbpBase from "@/lib/abpbase";
import Print from 'vue-print-nb'
import * as moment from 'moment';
Vue.use(Print);
class SessionInfo
{
    transferredTime: Date;
    tplContactName :string;
    tplContactPhone :string;
    tplName :string;
    tplFullAddress:string;
    warehouseCode :string;
    warehouseName :string;
    warehouseContactPhone :string;
    warehouseFullAddress :string;
    items = []
}
@Component

export default class PrinterHandoverSessionTplReport extends AbpBase{
  @Prop({ type: Boolean, default: false }) value: boolean;
  id : number;
  session : SessionInfo = new SessionInfo() ;
  get loading(){
      return false;
  }
  get transferredTime() {
        if(Util.isNull(this.session) || Util.isNull(this.session.transferredTime))
            return '';
        return moment.utc(String(this.session.transferredTime)).local().format(AppConsts.viewDateFormat);
}
  async created(){
    this.id = +this.$root.$router.currentRoute.params.id;
    await this.$store
      .dispatch({
          type:'handoverSession/getHandoverSessionTplReport',
          data: { id : this.id}
      })
      .then((res) => {
        this.session = res;
         let index = 0;
        this.session.items.forEach((item) => {
           item.orderNo = index + 1;
              index++;
        });
      });
  }
}

window.onbeforeprint = BeforePrint;
let heightA4 = 950;

function BeforePrint () {
    var elements = document.getElementsByClassName("box");
    for (var i = 0; i < elements.length; i++) {
        let element = elements[i] as HTMLElement;
        let rootHeigth = element.clientHeight;
        let division = Math.floor(rootHeigth / heightA4);
        let remainder = rootHeigth % heightA4;
        if(remainder > 0){
          let remainderHeight = remainder > 0 ? 1 : 0;
          let newHeight = (division + remainderHeight) * 950;
          element.style.height = newHeight + "px";
        }
    }
}
